{
  "levelCap": 60,
  "xpFormula": {
    "base": 120,
    "exponent": 2.2
  },
  "statPointsPerLevel": 3,
  "deathXpPenalty": 0.03,
  "deathPenaltyMinLevel": 10,
  "mobXp": {
    "penaltyStartsAtLevelsBelow": 3,
    "penaltyPerLevel": 0.15,
    "minMult": 0.1,
    "bonusPerLevelAbove": 0.05,
    "maxBonus": 0.25
  }
}
